const en = {
  pageTitle: "AI Studio",
  versionHistory: "Version history",
  showHistory: "Show version history",
  hideHistory: "Hide version history",
  chatTab: "Chat",
  previewTab: "Preview",
  viewLabel: "Studio view",
  previewLabel: "Store preview",
  pageSelect: "Page",
  pageHome: "Home",
  pageProducts: "All products",
  pageCollections: "Collections",
  languageSelect: "Preview language",
  device: "Device",
  desktop: "Desktop",
  tablet: "Tablet",
  mobile: "Mobile",
  editToggle: "Edit text, colors & photos directly",
  editDefaultOnly: "Direct editing works in your store's default language. Switch the preview language to edit.",
  editNotAllowed: "You don't have permission to edit this store's design.",
  refresh: "Refresh preview",
  openNewTab: "Open in a new tab",
  editHint: "Click text to type · click a photo to swap it · pick colors — saves to your draft",
  cancelEdit: "Cancel",
  colorPrimary: "Brand",
  colorBackground: "Background",
  colorText: "Text",
  colorsLabel: "Theme colors",
  saving: "Saving…",
  saved: "Saved to draft",
  saveFailed: "Couldn't save: {error}",
  dismiss: "Dismiss",
  bridgeSave: "Save",
  bridgeCancel: "Cancel",
  errTarget: "This element can't be edited here.",
  errPage: "This page no longer exists. Refresh the preview.",
  errSection: "This section no longer exists. Refresh the preview.",
  errField: "This field can't be edited directly.",
  errImage: "Choose an image from your media library.",
  errColor: "Pick a valid color.",
  heroTitle: "Describe it. We'll build it.",
  heroSubtitle: "Tell the AI what you sell and the style you like — it builds the theme, pages and navigation for you.",
  heroPlaceholder: "e.g. I want to create a jackets store named Jaketo — only men's jackets, currency MAD, based in Morocco, site in French…",
  heroInputLabel: "Describe your store",
  heroPlan: "Plan",
  heroPlanHint: "See a step-by-step plan before anything is built",
  heroGenerate: "Generate",
  heroOutOfCredits: "You're out of credits — fund your wallet to continue building",
  heroFundNow: "Fund your wallet now →",
  heroTalk: "Not sure how to start? Talk to a Storelancer AI",
};

export default en;
